import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postApi } from "../../api/getUser";

const initialState = {
  partCategory: null,
  allPartCategories: [],
};

export const fetchPartCategories = createAsyncThunk(
  "parts/fetchPartCategories",
  async ({ force } = {}, { getState, rejectWithValue }) => {
    const state = getState();
    const existing = state.parts?.allPartCategories || [];
    if (!force && Array.isArray(existing) && existing.length > 0) {
      return { categories: existing, fromCache: true };
    }
    try {
      const res = await postApi(
        { querystring: "fetch_all_part_categories" },
        "inventory"
      );
      const raw = res?.inventory_data;
      const categories = Array.isArray(raw)
        ? raw.map((c) => ({ label: c.category_name, value: c.category_id }))
        : [];
      return { categories };
    } catch (e) {
      return rejectWithValue(e?.message || "failed_to_fetch_categories");
    }
  }
);

const partsSlice = createSlice({
  name: "parts",
  initialState,
  reducers: {
    setPartCategory(state, action) {
      state.partCategory = action.payload ?? null;
    },
    setAllPartCategories(state, action) {
      state.allPartCategories = Array.isArray(action.payload)
        ? action.payload
        : [];
    },
    clearPartsUi(state) {
      state.partCategory = null;
      state.allPartCategories = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPartCategories.fulfilled, (state, action) => {
      const { categories } = action.payload || {};
      if (Array.isArray(categories)) {
        state.allPartCategories = categories;
      }
    });
  },
});

export const { setPartCategory, setAllPartCategories, clearPartsUi } =
  partsSlice.actions;

export default partsSlice.reducer;
